// @flow
// This file is auto-generated. Please use `cd docs && yarn generate-glossary-messages` to regenerate

import {defineMessages} from 'react-intl';

export const termMessages = defineMessages({
  'asynchronous-payment-methods': {
    id: 'docsApp.glossary.term.asynchronousPaymentMethods',
    description: 'A glossary term used in docs',
    defaultMessage: 'asynchronous payment methods',
  },
  'card-authentication': {
    id: 'docsApp.glossary.term.cardAuthentication',
    description: 'A glossary term used in docs',
    defaultMessage: 'card authentication',
  },
  'checkout-session': {
    id: 'docsApp.glossary.term.checkoutSession',
    description: 'A glossary term used in docs',
    defaultMessage: 'checkout session',
  },
  connect: {
    id: 'docsApp.glossary.term.connect',
    description: 'A glossary term used in docs',
    defaultMessage: 'Connect',
  },
  'conversion-on-session': {
    id: 'docsApp.glossary.term.conversionOnSession',
    description: 'A glossary term used in docs',
    defaultMessage: 'conversion on-session',
  },
  customers: {
    id: 'docsApp.glossary.term.customers',
    description: 'A glossary term used in docs',
    defaultMessage: 'Customers',
  },
  'customer-portal': {
    id: 'docsApp.glossary.term.customerPortal',
    description: 'A glossary term used in docs',
    defaultMessage: 'customer portal',
  },
  'direct-to-authorization': {
    id: 'docsApp.glossary.term.directToAuthorization',
    description: 'A glossary term used in docs',
    defaultMessage: 'direct to authorization',
  },
  'dunning-email': {
    id: 'docsApp.glossary.term.dunningEmail',
    description: 'A glossary term used in docs',
    defaultMessage: 'dunning email',
  },
  eea: {
    id: 'docsApp.glossary.term.eea',
    description: 'A glossary term used in docs',
    defaultMessage: 'European Economic Area',
  },
  emv: {
    id: 'docsApp.glossary.term.emv',
    description: 'A glossary term used in docs',
    defaultMessage: 'EMV',
  },
  'fsa-hsa': {
    id: 'docsApp.glossary.term.fsaHsa',
    description: 'A glossary term used in docs',
    defaultMessage: 'FSA/HSA',
  },
  fulfillment: {
    id: 'docsApp.glossary.term.fulfillment',
    description: 'A glossary term used in docs',
    defaultMessage: 'fulfillment',
  },
  GDPR: {
    id: 'docsApp.glossary.term.gdpr',
    description: 'A glossary term used in docs',
    defaultMessage: 'General Data Protection Regulation',
  },
  GST: {
    id: 'docsApp.glossary.term.gst',
    description: 'A glossary term used in docs',
    defaultMessage: 'GST',
  },
  IBAN: {
    id: 'docsApp.glossary.term.iban',
    description: 'A glossary term used in docs',
    defaultMessage: 'IBAN',
  },
  iDeal: {
    id: 'docsApp.glossary.term.iDeal',
    description: 'A glossary term used in docs',
    defaultMessage: 'iDeal',
  },
  'incremental-onboarding': {
    id: 'docsApp.glossary.term.incrementalOnboarding',
    description: 'A glossary term used in docs',
    defaultMessage: 'incremental onboarding',
  },
  'intent-confirmation': {
    id: 'docsApp.glossary.term.intentConfirmation',
    description: 'A glossary term used in docs',
    defaultMessage: 'confirm',
  },
  'intent-confirmation-generic': {
    id: 'docsApp.glossary.term.intentConfirmationGeneric',
    description: 'A glossary term used in docs',
    defaultMessage: 'confirm',
  },
  'intent-secret': {
    id: 'docsApp.glossary.term.intentSecret',
    description: 'A glossary term used in docs',
    defaultMessage: 'client secret',
  },
  interchange: {
    id: 'docsApp.glossary.term.interchange',
    description: 'A glossary term used in docs',
    defaultMessage: 'interchange fee',
  },
  invoices: {
    id: 'docsApp.glossary.term.invoices',
    description: 'A glossary term used in docs',
    defaultMessage: 'invoices',
  },
  KYC: {
    id: 'docsApp.glossary.term.kyc',
    description: 'A glossary term used in docs',
    defaultMessage: 'know your customer',
  },
  'liability-shift': {
    id: 'docsApp.glossary.term.liabilityShift',
    description: 'A glossary term used in docs',
    defaultMessage: 'liability shift',
  },
  'merchant-initiated-transaction': {
    id: 'docsApp.glossary.term.merchantInitiatedTransaction',
    description: 'A glossary term used in docs',
    defaultMessage: 'merchant-initiated transaction',
  },
  'metered-billing': {
    id: 'docsApp.glossary.term.meteredBilling',
    description: 'A glossary term used in docs',
    defaultMessage: 'metered billing',
  },
  offlinePin: {
    id: 'docsApp.glossary.term.offlinePin',
    description: 'A glossary term used in docs',
    defaultMessage: 'Offline PIN',
  },
  'off-session': {
    id: 'docsApp.glossary.term.offSession',
    description: 'A glossary term used in docs',
    defaultMessage: 'off-session payment',
  },
  onlinePIN: {
    id: 'docsApp.glossary.term.onlinePin',
    description: 'A glossary term used in docs',
    defaultMessage: 'Online PIN',
  },
  'on-session': {
    id: 'docsApp.glossary.term.onSession',
    description: 'A glossary term used in docs',
    defaultMessage: 'on-session payment',
  },
  'payment-intents': {
    id: 'docsApp.glossary.term.paymentIntents',
    description: 'A glossary term used in docs',
    defaultMessage: 'Payment Intents API',
  },
  'payment-methods': {
    id: 'docsApp.glossary.term.paymentMethods',
    description: 'A glossary term used in docs',
    defaultMessage: 'PaymentMethods',
  },
  payout: {
    id: 'docsApp.glossary.term.payout',
    description: 'A glossary term used in docs',
    defaultMessage: 'payout',
  },
  'pci-compliance': {
    id: 'docsApp.glossary.term.pciCompliance',
    description: 'A glossary term used in docs',
    defaultMessage: 'PCI compliance',
  },
  'presentment-currency': {
    id: 'docsApp.glossary.term.presentmentCurrency',
    description: 'A glossary term used in docs',
    defaultMessage: 'presentment currency',
  },
  prices: {
    id: 'docsApp.glossary.term.prices',
    description: 'A glossary term used in docs',
    defaultMessage: 'Prices',
  },
  'pricing-model': {
    id: 'docsApp.glossary.term.pricingModel',
    description: 'A glossary term used in docs',
    defaultMessage: 'pricing model',
  },
  products: {
    id: 'docsApp.glossary.term.products',
    description: 'A glossary term used in docs',
    defaultMessage: 'Products',
  },
  'products-subs': {
    id: 'docsApp.glossary.term.productsSubs',
    description: 'A glossary term used in docs',
    defaultMessage: 'subscription products',
  },
  radar: {
    id: 'docsApp.glossary.term.radar',
    description: 'A glossary term used in docs',
    defaultMessage: 'Radar',
  },
  requires_action: {
    id: 'docsApp.glossary.term.requiresAction',
    description: 'A glossary term used in docs',
    defaultMessage: 'requires_action',
  },
  requires_payment_method: {
    id: 'docsApp.glossary.term.requiresPaymentMethod',
    description: 'A glossary term used in docs',
    defaultMessage: 'requires_payment_method',
  },
  reverse_charge: {
    id: 'docsApp.glossary.term.reverseCharge',
    description: 'A glossary term used in docs',
    defaultMessage: 'reverse_charge_mechanism',
  },
  sca: {
    id: 'docsApp.glossary.term.sca',
    description: 'A glossary term used in docs',
    defaultMessage: 'Strong Customer Authentication',
  },
  'sca-exemptions': {
    id: 'docsApp.glossary.term.scaExemptions',
    description: 'A glossary term used in docs',
    defaultMessage: 'SCA exemptions',
  },
  'settlement-currency': {
    id: 'docsApp.glossary.term.settlementCurrency',
    description: 'A glossary term used in docs',
    defaultMessage: 'settlement currency',
  },
  'setup-intents': {
    id: 'docsApp.glossary.term.setupIntents',
    description: 'A glossary term used in docs',
    defaultMessage: 'Setup Intents API',
  },
  'setup-intent-secret': {
    id: 'docsApp.glossary.term.setupIntentSecret',
    description: 'A glossary term used in docs',
    defaultMessage: 'setup intent client secret',
  },
  sku: {
    id: 'docsApp.glossary.term.sku',
    description: 'A glossary term used in docs',
    defaultMessage: 'SKU',
  },
  'stripe-js': {
    id: 'docsApp.glossary.term.stripeJs',
    description: 'A glossary term used in docs',
    defaultMessage: 'Stripe.JS',
  },
  subscriptions: {
    id: 'docsApp.glossary.term.subscriptions',
    description: 'A glossary term used in docs',
    defaultMessage: 'subscriptions',
  },
  'three-d-secure': {
    id: 'docsApp.glossary.term.threeDSecure',
    description: 'A glossary term used in docs',
    defaultMessage: '3D Secure',
  },
  'test-mode': {
    id: 'docsApp.glossary.term.testMode',
    description: 'A glossary term used in docs',
    defaultMessage: 'test mode',
  },
  tls: {
    id: 'docsApp.glossary.term.tls',
    description: 'A glossary term used in docs',
    defaultMessage: 'TLS',
  },
  VAT: {
    id: 'docsApp.glossary.term.vat',
    description: 'A glossary term used in docs',
    defaultMessage: 'VAT',
  },
  'universal-links': {
    id: 'docsApp.glossary.term.universalLinks',
    description: 'A glossary term used in docs',
    defaultMessage: 'universal-links',
  },
  'upfront-onboarding': {
    id: 'docsApp.glossary.term.upfrontOnboarding',
    description: 'A glossary term used in docs',
    defaultMessage: 'upfront onboarding',
  },
  webhook: {
    id: 'docsApp.glossary.term.webhook',
    description: 'A glossary term used in docs',
    defaultMessage: 'webhook',
  },
});

export const definitionMessages = defineMessages({
  'asynchronous-payment-methods': {
    id: 'docsApp.glossary.definition.asynchronousPaymentMethods',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      "Asynchronous payment methods can take up to several days to confirm whether the payment has been successful. During this time, the payment can't be guaranteed.\n",
  },
  'card-authentication': {
    id: 'docsApp.glossary.definition.cardAuthentication',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'A bank may require the customer to authenticate a card payment before processing. Implementation varies by bank but commonly consists of a customer entering in a security code sent to their phone.\n',
  },
  'checkout-session': {
    id: 'docsApp.glossary.definition.checkoutSession',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      "A Checkout Session represents your customer's session as they pay for one-time purchases or subscriptions through Checkout. After a successful payment, the Checkout Session contains a reference to the Customer, and either the successful PaymentIntent or an active Subscription.\n",
  },
  connect: {
    id: 'docsApp.glossary.definition.connect',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      "Connect is Stripe's solution for any business that needs to process payments and pay out to sellers and service providers.\n",
  },
  'conversion-on-session': {
    id: 'docsApp.glossary.definition.conversionOnSession',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'A payment is described as on-session if it occurs with the direct involvement of the customer. Off-session transactions rely on previously-collected payment information.\n',
  },
  customers: {
    id: 'docsApp.glossary.definition.customers',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Stripe Customer objects allow you to perform recurring charges for the same customer, and to track multiple charges. If you create subscriptions, the subscription id is passed to the customer object.\n',
  },
  'customer-portal': {
    id: 'docsApp.glossary.definition.customerPortal',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'The customer portal is a secure, Stripe-hosted page that lets your customers manage their subscriptions and billing details.\n',
  },
  'direct-to-authorization': {
    id: 'docsApp.glossary.definition.directToAuthorization',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Where Stripe requests a SCA exemption as part of the authorization message.\n',
  },
  'dunning-email': {
    id: 'docsApp.glossary.definition.dunningEmail',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'A dunning email helps prevent lost revenue by asking a customer to update their payment method. You can define the schedule to send these payment reminder emails in your Subscriptions and email settings.\n',
  },
  eea: {
    id: 'docsApp.glossary.definition.eea',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'The European Economic Area is a regional single market with free movement of labor, goods, and capital. It encompasses the European Union member states and three additional states that are part of the European Free Trade Association.\n',
  },
  emv: {
    id: 'docsApp.glossary.definition.emv',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'EMV refers to the standards governing acceptance of chip-enabled cards and some contactless payment methods. Today most payment cards issued around the world support EMV.\n',
  },
  'fsa-hsa': {
    id: 'docsApp.glossary.definition.fsaHsa',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Flexible Spending Account or Health Savings Account debit cards use pre-tax funds to cover certain types of purchases, such as medical expenses. Their use is restricted only to businesses that directly provide eligible products and services.\n',
  },
  fulfillment: {
    id: 'docsApp.glossary.definition.fulfillment',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Fulfillment is the process of providing the goods or services purchased by a customer, typically after payment is collected.\n',
  },
  GDPR: {
    id: 'docsApp.glossary.definition.gdpr',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'GDPR is a regulation in EU law on data protection and privacy in the European (EU) and the European Economic Area (EEA).\n',
  },
  GST: {
    id: 'docsApp.glossary.definition.gst',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'A goods and services tax (GST), known in some countries as a value added tax (VAT), is a type of tax levied on the price of a product or service at each stage of production, distribution, or sale to the end consumer. GST and VAT are also generally known as "consumption" taxes. The buyer pays the tax and the seller forwards it to the government.\n',
  },
  IBAN: {
    id: 'docsApp.glossary.definition.iban',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'The International Bank Account Number (IBAN) identifies bank accounts across national borders to facilitate cross border transactions with a reduced risk of transcription errors. An IBAN uniquely identifies the account of a customer at a financial institution.\n',
  },
  iDeal: {
    id: 'docsApp.glossary.definition.iDeal',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      "iDeal is a payment method in the Netherlands that uses direct, online transfers from the user's bank account.\n",
  },
  'incremental-onboarding': {
    id: 'docsApp.glossary.definition.incrementalOnboarding',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Incremental onboarding is a type of onboarding where you gradually collect required verification information from your users. You collect a minimum amount of information at sign-up, and you collect more information as the connected account earns more revenue.\n',
  },
  'intent-confirmation': {
    id: 'docsApp.glossary.definition.intentConfirmation',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Confirming a PaymentIntent indicates that the customer intends to pay with the current or provided payment method. Upon confirmation, the PaymentIntent attempts to initiate a payment.\n',
  },
  'intent-confirmation-generic': {
    id: 'docsApp.glossary.definition.intentConfirmationGeneric',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Confirming an intent indicates that the customer intends to use the current or provided payment method. Upon confirmation, the intent attempts to initiate the portions of the flow that have real-world side effects.\n',
  },
  'intent-secret': {
    id: 'docsApp.glossary.definition.intentSecret',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'The client secret is a unique key returned from Stripe as part of a PaymentIntent. This key lets the client access important fields from the PaymentIntent (e.g., status) while hiding sensitive ones (e.g., amount).\n',
  },
  interchange: {
    id: 'docsApp.glossary.definition.interchange',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Interchange or interchange fee is a term used by the card networks to describe a fee paid between banks for the acceptance of card-based transactions. Usually it\'s a fee on transactions that a merchant\'s bank (the "acquiring bank") pays a customer\'s bank (the "issuing bank").\n',
  },
  invoices: {
    id: 'docsApp.glossary.definition.invoices',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Invoices are statements of amounts owed by a customer. They track the status of payments from draft through paid or otherwise finalized. Subscriptions automatically generate invoices, or you can manually create a one-off invoice.\n',
  },
  KYC: {
    id: 'docsApp.glossary.definition.kyc',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Know your customer (KYC) regulations require that professionals and businesses make an effort to verify the identity, suitability, and risks involved with maintaining a business relationship. The procedures fall under the broader scope of anti-money laundering (AML) policy.\n',
  },
  'liability-shift': {
    id: 'docsApp.glossary.definition.liabilityShift',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'The liability for fraudulent chargebacks (stolen or counterfeit cards) shifts from you to the card issuer.\n',
  },
  'merchant-initiated-transaction': {
    id: 'docsApp.glossary.definition.merchantInitiatedTransaction',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'A payment made off-session with a properly authenticated saved card, can qualify as merchant-initiated transaction and be exempt from SCA.\n',
  },
  'metered-billing': {
    id: 'docsApp.glossary.definition.meteredBilling',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Metered billing is a subcription billing model where you charge your customers based on their consumption of your service during the billing cycle, instead of explicitly setting quantities.\n',
  },
  offlinePin: {
    id: 'docsApp.glossary.definition.offlinePin',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Offline PIN is a card verification method for EMV chip cards. These cards store the PIN securely on the chip itself, so PIN verification can occur without a network connection.\n',
  },
  'off-session': {
    id: 'docsApp.glossary.definition.offSession',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'A payment is described as off-session if it occurs without the direct involvement of the customer, using previously-collected payment information.\n',
  },
  onlinePIN: {
    id: 'docsApp.glossary.definition.onlinePin',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Online PIN is a card verification method for EMV chip cards. These cards require the terminal to contact the issuer over a network connection to verify the PIN.\n',
  },
  'on-session': {
    id: 'docsApp.glossary.definition.onSession',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'A payment is described as on-session if it occurs while the customer is actively in your checkout flow and able to authenticate the payment method.\n',
  },
  'payment-intents': {
    id: 'docsApp.glossary.definition.paymentIntents',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'The Payment Intents API is a new way to build dynamic payment flows. It tracks the lifecycle of a customer checkout flow and triggers additional authentication steps when required by regulatory mandates, custom Radar fraud rules, or redirect-based payment methods.\n',
  },
  'payment-methods': {
    id: 'docsApp.glossary.definition.paymentMethods',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      "PaymentMethods represent your customer's payment instruments, used with the Payment Intents or Setup Intents APIs.\n",
  },
  payout: {
    id: 'docsApp.glossary.definition.payout',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'A payout is the transfer of funds to a bank account in the form of a deposit.\n',
  },
  'pci-compliance': {
    id: 'docsApp.glossary.definition.pciCompliance',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Any party involved in processing, transmitting, or storing credit card data must comply with the rules specified in the the Payment Card Industry (PCI) Data Security Standards. PCI compliance is a shared responsibility and applies to both Stripe and your business.\n',
  },
  'presentment-currency': {
    id: 'docsApp.glossary.definition.presentmentCurrency',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'The presentment currency is the currency the customer uses to make a payment.\n',
  },
  prices: {
    id: 'docsApp.glossary.definition.prices',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Prices define how much and how often to charge for products. This includes how much the product costs, what currency to use, and the interval if the price is for subscriptions.\n',
  },
  'pricing-model': {
    id: 'docsApp.glossary.definition.pricingModel',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'The pricing model consists of the products or services you sell, how much they cost, what currency you accept for payments, and the interval to charge (for subscriptions). To build the pricing model, you use Products—what you sell—and Prices—how much and how often to charge for your products.\n',
  },
  products: {
    id: 'docsApp.glossary.definition.products',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      "Products represent what your business sells—whether that's a good or a service.\n",
  },
  'products-subs': {
    id: 'docsApp.glossary.definition.productsSubs',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Products represent items your customer can subscribe to with a Subscription. An associated Price object describes the pricing and other terms of the subscription.\n',
  },
  radar: {
    id: 'docsApp.glossary.definition.radar',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Stripe Radar helps detect and block fraud for any type of business using machine learning that trains on data across millions of global companies. It’s built into Stripe and requires no additional setup to get started.\n',
  },
  requires_action: {
    id: 'docsApp.glossary.definition.requiresAction',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'This status appears as "requires_source_action" in API versions before 2019-02-11.\n',
  },
  requires_payment_method: {
    id: 'docsApp.glossary.definition.requiresPaymentMethod',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'This status appears as "requires_source" in API versions before 2019-02-11.\n',
  },
  reverse_charge: {
    id: 'docsApp.glossary.definition.reverseCharge',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'The reverse charge mechanism is a system in which the responsibility of paying VAT or GST to the government shifts from the seller to the buyer.\n',
  },
  sca: {
    id: 'docsApp.glossary.definition.sca',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Strong Customer Authentication (SCA) is a regulatory requirement in effect as of September 14, 2019, that impacts many European online payments. It requires customers to use two-factor authentication like 3D Secure to verify their purchase.\n',
  },
  'sca-exemptions': {
    id: 'docsApp.glossary.definition.scaExemptions',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      "Some transactions that are deemed low risk, based on the volume of fraud rates associated with the payment provider or bank, may be exempt from Europe's Strong Customer Authentication requirements.\n",
  },
  'settlement-currency': {
    id: 'docsApp.glossary.definition.settlementCurrency',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'The settlement currency is the currency your bank account uses.\n',
  },
  'setup-intents': {
    id: 'docsApp.glossary.definition.setupIntents',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'The Setup Intents API lets you build dynamic flows for collecting payment method details for future payments. It tracks the lifecycle of a payment setup flow and can trigger additional authentication steps if required by law or by the payment method.\n',
  },
  'setup-intent-secret': {
    id: 'docsApp.glossary.definition.setupIntentSecret',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'The client secret is a unique key returned from Stripe as part of a SetupIntent. This key lets the client access important fields from the SetupIntent (e.g., status).\n',
  },
  sku: {
    id: 'docsApp.glossary.definition.sku',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'SKUs (Stock Keeping Units) represent a specific Product variation, taking into account any combination of attributes and cost (for instance, size, color, currency, cost).\n',
  },
  'stripe-js': {
    id: 'docsApp.glossary.definition.stripeJs',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Use Stripe.js’ APIs to tokenize customer information, collect sensitive card data, and accept payments with browser payment APIs.\n',
  },
  subscriptions: {
    id: 'docsApp.glossary.definition.subscriptions',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'A Subscription represents the product details associated with the plan that your customer subscribes to. Allows you to charge the customer on a recurring basis.\n',
  },
  'three-d-secure': {
    id: 'docsApp.glossary.definition.threeDSecure',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      '3D Secure provides an additional layer of authentication for credit card transactions that protects merchants from liability for fraudulent card payments.\n',
  },
  'test-mode': {
    id: 'docsApp.glossary.definition.testMode',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      "Test mode is a way to test changes to to your integration without affecting production. All Stripe features are available in test mode but you can't create live charges until you activate it.\n",
  },
  tls: {
    id: 'docsApp.glossary.definition.tls',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'TLS refers to the process of securely transmitting data between the client—the app or browser that your customer is using—and your server. This was originally performed using the SSL (Secure Sockets Layer) protocol.\n',
  },
  VAT: {
    id: 'docsApp.glossary.definition.vat',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'A value-added tax (VAT), known in some countries as a goods and services tax (GST), is a type of tax levied on the price of a product or service at each stage of production, distribution, or sale to the end consumer. VAT and GST are also generally known as "consumption" taxes. The buyer pays the tax and the seller forwards it to the government.\n',
  },
  'universal-links': {
    id: 'docsApp.glossary.definition.universalLinks',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      "Use Universal links on iOS and macOS to link directly to in-app content. They're standard HTTPS links, so the same URL works for your website and your app.\n",
  },
  'upfront-onboarding': {
    id: 'docsApp.glossary.definition.upfrontOnboarding',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'Upfront onboarding is a type of onboarding where you collect all required verification information from your users at sign-up.\n',
  },
  webhook: {
    id: 'docsApp.glossary.definition.webhook',
    description: 'A definition of a glossary term used in docs',
    defaultMessage:
      'A webhook is a real-time push notification sent to your application as a JSON payload through HTTPS requests.\n',
  },
});
